export function cleanupSelected(selected, mol) {
  const retain = [];

  for (const key of selected) {
    if (mol.atoms[key] != null) {
      retain.push(key);
    }
  }

  return retain.length === selected.length ? selected : retain;
}
